import { createSlice } from '@reduxjs/toolkit';
const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    isSending: false,
    stopTyping: false,
    conversationExternalRef: '',
    reportGeneratesIdentification: false,
    isReport: false,
    refClearInterval: '',
    isShowFeedback: false,
    isShowSystemTour: false,
    isShowChatFeedbackFooter: false,
  },

  reducers: {
    setIsSending(state, action) {
      state.isSending = action.payload;
    },
    setStopTyping(state, action) {
      state.stopTyping = action.payload;
    },
    setConversationExternalRef(state, action) {
      state.conversationExternalRef = action.payload;
    },
    setReportGeneratesIdentification(state, action) {
      state.reportGeneratesIdentification = action.payload;
    },
    setIsReport(state, action) {
      state.isReport = action.payload;
    },
    setRefClearInterval(state, action) {
      state.refClearInterval = action.payload;
    },
    setIsShowFeedback(state, action) {
      state.isShowFeedback = action.payload;
    },
    setIsShowSystemTour(state, action) {
      state.isShowSystemTour = action.payload;
    },
    setIsShowChatFeedbackFooter(state, action) {
      state.isShowChatFeedbackFooter = action.payload;
    },
  },
});

export const {
  setIsSending,
  setStopTyping,
  setConversationExternalRef,
  setReportGeneratesIdentification,
  setIsReport,
  setRefClearInterval,
  setIsShowFeedback,
  setIsShowSystemTour,
  setIsShowChatFeedbackFooter,
} = chatSlice.actions;

export default chatSlice.reducer;
